import { IState } from '@/Interfaces/Slices/Forecaster/State.interface';
import type { RequestMap } from '@/types/RequestMap.types';

//#region reducers
export const requestMap: RequestMap<IState> = [];
//#endregion
